<template>
  <div class="global-header">
    <div class="brand" @click="router.push('/')">
      <div class="logo-mark">OJ</div>
      <div class="title">OJ 在线判题系统</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";

const router = useRouter();
</script>

<style scoped>
.global-header {
  display: flex;
  align-items: center;
}

.brand {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.logo-mark {
  display: grid;
  width: 26px;
  height: 26px;
  margin-right: 8px;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  place-items: center;
  background: #1677ff;
  border-radius: 50%;
}

.title {
  color: #111827;
  font-size: 16px;
  font-weight: 800;
}
</style>
